import { useState } from 'react'
import SeccionCelulares from './SeccionCelulares'
import SeccionAccesorios from './SeccionAccesorios'
import './Inventario.css'

export default function Inventario({ toast, comercioId }) {
  const [activeTab, setActiveTab] = useState('celulares')

  return (
    <div className="inv-container">
      <header className="inv-header-flex">
        <div>
          <h1 className="inv-title">Inventario General</h1>
          <p className="inv-subtitle">Gestiona de forma centralizada tus equipos y productos en stock.</p>
        </div>

        <div className="inv-segmented-control">
          <button 
            className={`control-btn ${activeTab === 'celulares' ? 'active' : ''}`}
            onClick={() => setActiveTab('celulares')}
          >
            Celulares
          </button>
          <button 
            className={`control-btn ${activeTab === 'accesorios' ? 'active' : ''}`}
            onClick={() => setActiveTab('accesorios')}
          >
            Accesorios Sueltos
          </button>
        </div>
      </header>

      {/* Renderizado Condicional de las Sub-Pantallas */}
      {activeTab === 'celulares' ? (
        <SeccionCelulares toast={toast} comercioId={comercioId} />
      ) : (
        <SeccionAccesorios toast={toast} comercioId={comercioId} />
      )}
    </div>
  )
}